import { Reveal } from "./Services";

const STEPS = [
  {
    num: "01",
    title: "Escolha & Briefing",
    text: "Você escolhe o serviço, preenche o formulário e conta tudo sobre a sua ideia.",
  },
  {
    num: "02",
    title: "Confirmação & Pix",
    text: "Você recebe por e-mail o resumo do pedido, a chave Pix e nosso número de contato.",
  },
  {
    num: "03",
    title: "Criação & Alinhamento",
    text: "Criamos a sua arte e ajustamos os detalhes com você até ficar do seu jeito.",
  },
  {
    num: "04",
    title: "Entrega Final",
    text: "Arquivos finais em alta resolução, prontos para usar na sua marca.",
  },
];

export default function Process() {
  return (
    <section id="processo" className="border-t border-line bg-paper2 py-20 sm:py-32 lg:py-40" data-testid="process-section">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-14 px-6 sm:px-12 lg:grid-cols-12 lg:px-20">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-ink-3">02 — Processo</p>
            <h2 className="mt-6 font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
              Simples do briefing à entrega.
            </h2>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-ink-2 sm:text-base">
              Sem burocracia: você pede, paga pelo Pix e acompanha cada etapa com o estúdio pelo WhatsApp.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <div className="flex flex-col">
            {STEPS.map((step, i) => (
              <Reveal key={step.num} delay={i * 0.08}>
                <div className="flex items-start gap-8 border-t border-line py-8 sm:gap-12" data-testid={`process-step-${step.num}`}>
                  <span className="font-display text-3xl font-extrabold text-butter sm:text-4xl">{step.num}</span>
                  <div>
                    <h3 className="font-display text-xl font-bold tracking-tight sm:text-2xl">{step.title}</h3>
                    <p className="mt-2 max-w-md text-sm leading-relaxed text-ink-2 sm:text-base">{step.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
